import { fetchToken } from "../../../common/FetchCookie"
import { BASE_URL, PROFILE, PROFILE_VERIFICATION_PHONE, PUBLIC } from "../../../common/URLs"

export const checkPhoneVerificationPublic = async ({ mobile, code }) => {
    const url = `${BASE_URL}/${PUBLIC}/${PROFILE}/${PROFILE_VERIFICATION_PHONE}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            // Send data in correct format: { mobile: "...", code: "..." }
            body: JSON.stringify({ mobile, code }),
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.message || "Failed to verify phone.")
        }
        const data = await response.json()
        return data
    } catch (error) {
        console.error("Error checking phone verification:", error)
        throw error
    }
}